export default __webpack_public_path__ + "static/OPTIMA-20932a305858c4e79b57816a79a6a3b9.woff";